<template>
  <AccessHandler :requiredRoleGroups="roleGroups" @accessChanged="(access: boolean) => (hasAccess = access)" />
  <div class="plant-visit-details-page" data-cy="plant-visit-details-page">
    <MasterPage>
      <template v-if="hasAccess" #content>
        <PlantVisitDetailsView :requestedVisitId="visitId" />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { UserRoles } from "@/Domain/UserRoles";
import type { RoleGroup } from "@/shared/access/RoleGroups";
import MasterPage from "@/views/MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import { useRoute } from "vue-router";
import PlantVisitDetailsView from "./PlantVisitDetailsView.vue";

const roleGroups = [{ roles: UserRoles.ROLES_COMPANY_RC_APPLICATION }] as RoleGroup[];

const hasAccess = ref(false);
const route = useRoute();

const parsePositiveInteger = (value: unknown) => {
  const stringValue = Array.isArray(value) ? value[0] : value;
  if (typeof stringValue !== "string" || !/^\d+$/.test(stringValue)) return undefined;

  const parsedValue = Number(stringValue);
  return Number.isSafeInteger(parsedValue) && parsedValue > 0 ? parsedValue : undefined;
};

const visitId = computed(() => parsePositiveInteger(route.params.visitId));
</script>

<style scoped lang="scss">
.plant-visit-details-page {
  min-height: 100vh;
}
</style>
